function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { makeResizeFilter } from "../utils";

var OutputBindingAdapter = /*#__PURE__*/function () {
  function OutputBindingAdapter(el, binding) {
    _classCallCheck(this, OutputBindingAdapter);

    _defineProperty(this, "el", void 0);

    _defineProperty(this, "binding", void 0);

    this.el = el;
    this.binding = binding; // If the binding actually has a resize method, override the prototype of
    // onResize with a version that does a makeResizeFilter on the element.

    if (binding.resize) {
      this.onResize = makeResizeFilter(el, function (width, height) {
        binding.resize(el, width, height);
      });
    }
  }

  _createClass(OutputBindingAdapter, [{
    key: "getId",
    value: function getId() {
      return this.binding.getId(this.el);
    }
  }, {
    key: "onValueChange",
    value: function onValueChange(data) {
      this.binding.onValueChange(this.el, data);
    }
  }, {
    key: "onValueError",
    value: function onValueError(err) {
      this.binding.onValueError(this.el, err);
    }
  }, {
    key: "showProgress",
    value: function showProgress(show) {
      this.binding.showProgress(this.el, show);
    }
  }, {
    key: "onResize",
    value: function onResize() {// Intentionally left blank; see constructor
    }
  }]);

  return OutputBindingAdapter;
}();

export { OutputBindingAdapter };